import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import {
  catchError,
  map
} from 'rxjs/operators';
import { AppConfigService } from '../services/config.service';

let headers = new HttpHeaders({
  // 'Content-Type': 'application/json',
  // 'Access-Control-Allow-Origin':  'http://127.0.0.1:4200',
  // 'Access-Control-Allow-Methods': ', GET',
  // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
  // 'Access-Control-Allow-Credentials': 'true',
  user_token: localStorage.getItem('token'),
});
let options = { headers: headers };

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private url = this.conf.appConfig.apiBaseUrl;
  private url2 = this.conf.appConfig.nodeBaseUrl;
  private urlonline = this.conf.appConfig.apiBaseUrl;

  logout() {
    const url = `${this.url}/api/accounts/logout`;
    const data = 'no';

    return this.client.post(url, data, options).pipe(
      map((data) => {
        localStorage.clear()
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  logouonline() {
    const url = `${this.urlonline}/api/accounts/logout`;
    const data = 'no';

    return this.client.post(url, data, options).pipe(
      map((data) => {
        localStorage.clear();
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  appVersion() {
    const url = `${this.url}/api/accounts/appversion`;

    const cacheData = localStorage.getItem('appversion');
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem('appversion', JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getTitle() {
    const url = `${this.url}/api/titles/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getTitleonline() {
    const url = `${this.urlonline}/api/titles/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  delSet(path, id) {
    const url = `${this.url}${path}/?id=${id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postTitle(name, gender) {
    const data = {
      name,
      gender,
    };
    console.log(data);
    const url = `${this.url}/api/titles/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  editTitle(name, gender, id) {
    const data = {
      name,
      gender,
      id,
    };
    const url = `${this.url}/api/titles/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getVoucher() {
    const url = `${this.url}/api/vouchers/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postVoucher(name, id) {
    const data = {
      name,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/vouchers/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getState() {
    const url = `${this.url}/api/geography/state/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postState(name, id, Country_Id) {
    const data = {
      name,
      id,
      Country_Id,
    };
    console.log(data);
    const url = `${this.url}/api/geography/state/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getCity() {
    const url = `${this.url}/api/geography/city/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postCity(name, id) {
    const data = {
      name,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/geography/city/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getcountry() {
    const url = `${this.url}/api/geography/country/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postCountry(name, id) {
    const data = {
      name,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/geography/country/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getBanks() {
    const url = `${this.url}/api/banks/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postBank(name, id) {
    const data = {
      name,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/banks/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getBranches() {
    const url = `${this.url}/api/companies/branch/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postBranch(
    Branch_Code,
    Branch_Name,
    company_name,
    Branch_Address,
    Telephone_No,
    Email_Id,
    Contact_Person,
    State_id,
    City_id,
    Status,
    id
  ) {
    const data = {
      Branch_Code,
      Branch_Name,
      company_name,
      Branch_Address,
      Telephone_No,
      Email_Id,
      Contact_Person,
      State_id,
      City_id,
      Status,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/companies/branch/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getCompanies() {
    const url = `${this.url}/api/companies/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postCompany(
    Company_code,
    Name,
    Address1,
    Address2,
    Tel_No,
    Email_Addr,
    billing_addr,
    Contact_Person,
    Contact_person_Designation,
    Contact_Person_Mobile_No,
    package_breakup,
    Payment_Type,
    status,
    Dis_Flag,
    discount,
    Remarks,
    Standard_Price_Valid_Id,
    Special_Price_Valid_Id
  ) {
    const data = {
      Company_code,
      Name,
      Address1,
      Address2,
      Tel_No,
      Email_Addr,
      billing_addr,
      Contact_Person,
      Contact_person_Designation,
      Contact_Person_Mobile_No,
      package_breakup,
      Payment_Type,
      status,
      Dis_Flag,
      discount,
      Remarks,
      Standard_Price_Valid_Id,
      Special_Price_Valid_Id,
    };
    console.log(data);
    const url = `${this.url}/api/companies/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getDept() {
    const url = `${this.url}/api/departments/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postDept(name, print_name, status, id) {
    const data = {
      name,
      print_name,
      status,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/departments/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getSubDept() {
    const url = `${this.url}/api/departments/sub/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postSubDept(name, dept_id, group_id, status, id) {
    const data = {
      name,
      dept_id,
      group_id,
      status,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/departments/sub/savesubdept`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getCategories() {
    const url = `${this.url}/api/employees/getallcategories`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getEmployees() {
    const url = `${this.url}/api/employees/getallemployees`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postOverideFinializer(
    result_id,
    initializer_userid,
    finalizer_userid,
    comment
  ) {
    const data = {
      result_id,
      initializer_userid,
      finalizer_userid,
      comment,
    };
    const url = `${this.url}/api/lab/result/overrides`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  postEmployee(
    id,
    employee_type_id,
    name,
    consultant_type,
    specialisation,
    department_code,
    registration_no,
    address1,
    address2,
    city_id,
    country_id,
    mobile,
    email_no,
    Designation,
    Nationality,
    write_off_authorised,
    concession_authorised,
    cancellation_authorised,
    Admission_Authorised,
    Indent_Authorisation,
    title_name,
    PO_AUTH,
    category_name,
    Status,
    qualification
  ) {
    const data = {
      id,
      employee_type_id,
      name,
      consultant_type,
      specialisation,
      department_code,
      registration_no,
      address1,
      address2,
      city_id,
      country_id,
      mobile,
      email_no,
      Designation,
      Nationality,
      write_off_authorised,
      concession_authorised,
      cancellation_authorised,
      Admission_Authorised,
      Indent_Authorisation,
      title_name,
      PO_AUTH,
      category_name,
      Status,
      qualification,
    };
    console.log(data);
    const url = `${this.url}/api/employees/saveemployee`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getCard() {
    const url = `${this.url}/api/employees/getallcardtypes`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getSocs() {
    const url = `${this.url}/api/soc/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postSocs(SOC_ID, SOC_NAME, SOC_Short_COde, SOC_REMARKs, Status, Author_Id) {
    const data = {
      SOC_ID,
      SOC_NAME,
      SOC_Short_COde,
      SOC_REMARKs,
      Status,
      Author_Id,
    };
    console.log(data);
    const url = `${this.url}/api/soc/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postAllotedSoc(soc_id, company_id, branch_code) {
    const data = {
      soc_id,
      company_id,
      branch_code,
    };
    console.log(data);
    const url = `${this.url}/api/soc/allotedsoc/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postSocsItem(SOC_ID, ITEM_ID, amount) {
    const data = {
      soc_id: SOC_ID,
      item_id: ITEM_ID,
      amount: +amount,
    };
    console.log(data);
    const url = `${this.url}/api/soc/save-soc-items`;

    return this.client.post(url, [data], options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  copySoc(
    select_soc: number,
    base_soc: number,
    rate_type: number,
    rate_percent: number,
    item_ids: string
  ) {
    const data = {
      select_soc,
      base_soc,
      rate_type,
      rate_percent,
      item_ids,
    };
    console.log(data);
    const url = `${this.url}/api/soc/copy-async`;
    console.log(data);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  addPriceSoc(data: any[]) {
    console.log(data);
    const url = `${this.url}/api/soc/save-soc-items`;
    console.log(data);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getSpecials() {
    const url = `${this.url}/api/specializations/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postSpecials(Spec_Name, Spec_Id, Status_Spec, Author_Id, Entry_Date) {
    const data = {
      Spec_Name,
      Spec_Id,
      Status_Spec,
      Author_Id,
      Entry_Date,
    };
    console.log(data);
    const url = `${this.url}/api/specializations/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getUom() {
    const url = `${this.url}/api/uom/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postUom(name, id) {
    const data = {
      name,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/uom/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getGroups() {
    const url = `${this.url}/api/groups/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postGroups(name, short_name, id) {
    const data = {
      name,
      short_name,
      id,
    };
    console.log(data);
    const url = `${this.url}/api/groups/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getAlocatedSoc() {
    const url = `${this.url}/api/soc/allotedsoc/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postAlocatedSoc(branch_code, company_id, soc_id) {
    const data = {
      branch_code,
      company_id,
      soc_id,
    };
    console.log(data);
    const url = `${this.url}/api/soc/allotedsoc/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getNation() {
    const url = `${this.url}/api/geography/national/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postNation(id, name) {
    const data = {
      id,
      name,
    };
    console.log(data);
    const url = `${this.url}/api/geography/national/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getItems() {
    const url = `${this.url}/api/items/getall?pagesize=100`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getItemBySocId(id) {
    const url = `${this.url}/api/items/getall?soc_id=${id}&pagesize=100`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getItems1(dept, subDept) {
    const url = `${this.url}/api/items/getall?pagesize=100&dept_id=${dept}&sub_dept_id=${subDept}`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getBillItems(patient_id, soc_id=0) {
    const url = soc_id ==0 ? `${this.url}/api/items/getall?pagesize=100&patient_id=${patient_id}` : `${this.url}/api/items/getall?pagesize=100&soc_id=${soc_id}`
    if (soc_id > 0) {
        var data = localStorage.getItem('items_' + soc_id);
        if (data != null) {
          return new Observable((observer) => {
            observer.next(JSON.parse(data ?? "[]"));
            observer.complete();
          }
        );
      }
    }
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        if (soc_id > 0) {
          localStorage.removeItem('items_' + soc_id);
          localStorage.setItem('items_' + soc_id, JSON.stringify(data));
        }
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }


  saveSocItem(soc_id, item_id, amount) {
    const data = {
      soc_id,
      item_id,
      amount,
    };
    const url = `${this.url}/api/soc/save-soc-items`;
    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  postItem(
    id,
    name,
    machine_code,
    dept_id,
    sub_dept_id,
    soc_id,
    direct_revenue,
    status,
    price_editable,
    one_time,
    doctor_reqd,
    NABL_Accredited,
    report_type,
    Daily,
    profile,
    release_dr_fee_when_unsettled,
    methodology,
    service_price,
    result_format_id
  ) {
    const data = {
      id,
      name,
      machine_code,
      dept_id,
      sub_dept_id,
      soc_id,
      direct_revenue,
      status,
      price_editable,
      one_time,
      doctor_reqd,
      NABL_Accredited,
      report_type,
      Daily,
      profile,
      release_dr_fee_when_unsettled,
      methodology,
      service_price,
      result_format_id,
    };
    console.log(data);
    const url = `${this.url}/api/items/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getOpd() {
    const url = `${this.url}/api/opdpackage/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postOpd(
    id,
    soc_id,
    dept_id,
    sub_dept_id,
    package_id,
    effective_date,
    soc_name,
    dept_name,
    sub_dept_name,
    package_name,
    pack_price,
    tot_serv_price,
    net_amt,
    item_of_service_id
  ) {
    const data = {
      id,
      soc_id,
      dept_id,
      sub_dept_id,
      package_id,
      effective_date,
      soc_name,
      dept_name,
      sub_dept_name,
      package_name,
      pack_price,
      tot_serv_price,
      net_amt,
      item_of_service_id,
    };
    console.log(data);
    const url = `${this.url}/api/opdpackage/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  getOpdDetail() {
    const url = `${this.url}/api/opdpackage/detail/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getOpdDetailPackage(pack_id) {
    const url = `${this.url}/api/opdpackage/detail/getall?pack_id=${pack_id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  deleteDetail(id, pack_id) {
    const url = `${this.url}/api/opdpackage/detail/delete?id=${id}&pack_id=${pack_id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postOpdDetail(
    id: number,
    pack_id: number,
    lstServices: [
      {
        service_id: number;
        service_name: string;
        service_price: number;
        discount_percent: number;
        discount_price: number;
        net_amt: number;
      }
    ]
  ) {
    const data = {
      id,
      pack_id,
      lstServices,
    };
    console.log(data);
    const url = `${this.url}/api/opdpackage/detail/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getSalesCard() {
    const url = `${
      this.url
    }/api/employees/salescard/getall?employee_id=${localStorage.getItem('id')}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postSalesCard(
    id,
    employee_id,
    branch_code,
    fin_year,
    card_type,
    barcode_no,
    card_comm,
    date_from,
    date_to
  ) {
    const data = {
      id,
      employee_id,
      branch_code,
      fin_year,
      card_type,
      barcode_no,
      card_comm,
      date_from,
      date_to,
    };
    console.log(data);
    const url = `${this.url}/api/employees/salescard/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getRefDr() {
    const url = `${this.url}/api/refdoctor/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getRefDrById(id) {
    const url = `${this.url}/api/refdoctor/getall?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postRefDr(
    ref_doctor_code,
    ref_doctor_name,
    Acount_Name,
    Account_No,
    Bank_Name,
    Share_per,
    Hospital_Name,
    mobile,
    Revenue_Shared,
    Status,
    Refer_Type_Code,
    Country,
    Designation,
    address1,
    address2,
    city,
    area,
    specialisation_code,
    email,
    U_Name,
    Password,
    branch_code,
    fin_year
  ) {
    const data = {
      ref_doctor_code,
      ref_doctor_name,
      Acount_Name,
      Account_No,
      Bank_Name,
      Share_per,
      Hospital_Name,
      mobile,
      Revenue_Shared,
      Status,
      Refer_Type_Code,
      Country,
      Designation,
      address1,
      address2,
      city,
      area,
      specialisation_code,
      email,
      U_Name,
      Password,
      branch_code,
      fin_year,
    };
    console.log(data);
    const url = `${this.url}/api/refdoctor/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error + 'Something went wrong please try again');
      })
    );
  }

  getSetUp(code) {
    const url = `${this.url}/api/setup/branch/billno/getall?branch_code=${code}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  postSetUp(number_mode, fin_yr, branch_code, bill_no) {
    const data = {
      number_mode,
      fin_yr,
      branch_code,
      bill_no,
    };
    console.log(data);
    const url = `${this.url}/api/setup/branch/billno/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getPatient() {
    const url = `${this.url}/api/patient/getall?pagesize=100`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getPatientList() {
    const url = `${this.url}/api/patient/getall?pagesize=100`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getPatientById(id) {
    const url = `${this.url}/api/patient/getall?pagesize=100&id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getPatientByBillId(bill_id) {
    const url = `${this.url}/api/patient/getall?pagesize=100&bill_id=${bill_id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postPatient(
    registration_no,
    Branch_Code,
    registration_date,
    religion_code,
    occupation_code,
    title_id,
    first_name,
    middle_name,
    father_name,
    sex,
    marital_status,
    bloodgroup,
    date_of_birth,
    local_address1,
    local_address2,
    local_city,
    local_state,
    local_country,
    ref_doct_code,
    nationality,
    mobile,
    E_mail_address,
    country_of_birth,
    status,
    BlackListedPatient,
    Author_id,
    Entry_date,
    booking_number,
    User_Id,
    Password,
    Barcode_No,
    card_per,
    special_note,
    payor_code,
    age,
    ageMonth,
    ageDays,
    numberOfChildren
  ) {
    const data = {
      registration_no,
      Branch_Code,
      registration_date,
      religion_code,
      occupation_code,
      title_id,
      first_name,
      middle_name,
      father_name,
      sex,
      marital_status,
      bloodgroup,
      date_of_birth,
      local_address1,
      local_address2,
      local_city,
      local_state,
      local_country,
      ref_doct_code,
      nationality,
      mobile,
      E_mail_address,
      country_of_birth,
      status,
      BlackListedPatient,
      Author_id,
      Entry_date,
      booking_number,
      User_Id,
      Password,
      Barcode_No,
      card_per,
      special_note,
      payor_code,
      age,
      ageMonth,
      ageDays,
      numberOfChildren,
    };
    console.log(data);
    const url = `${this.url}/api/patient/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postDoc(
    // Id,
    Mode,
    Name,
    Item_Of_Service_Id,
    Template_Text
  ) {
    const data = {
      // Id,
      Mode,
      Name,
      Item_Of_Service_Id,
      Template_Text,
    };
    console.log(data);
    const url = `${this.url}/api/doctemplates/save`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postDocument(Id, Mode, Name, Item_Of_Service_Id, Template_Text) {
    const data = {
      Id,
      Mode,
      Name,
      Item_Of_Service_Id,
      Template_Text,
    };
    console.log(data);
    const url = `${this.url}/api/doctemplates/save`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }
  newTemplate(Title, Body) {
    const data = {
      title: Title,
      messageBody: Body,
    };
    console.log(data);
    const url = `${this.url2}/api/Notifications/addTemplate`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  sendEmail(templateId, senderName, UsersData) {
    const data = {
      templateId,
      senderName,
      UsersData,
    };
    console.log(data);
    const url = `${this.url2}/api/Notifications/sendEmail`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  sendSMS(templateId, senderName, UsersData) {
    const data = {
      templateId,
      senderName,
      UsersData,
    };
    console.log(data);
    const url = `${this.url2}/api/Notifications/sendsms`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  updateTemplate(Id, Title, Body) {
    const data = {
      id: Id,
      title: Title,
      messageBody: Body,
    };
    console.log(data);
    const url = `${this.url2}/api/Notifications/updateTemplate`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  EditReceipt(Id, Mode, Name, Item_Of_Service_Id, Template_Text) {
    const data = {
      Id,
      Mode,
      Name,
      Item_Of_Service_Id,
      Template_Text,
    };
    console.log(data);
    const url = `${this.url}/api/doctemplates/save`;
    console.log(url);

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  sendDoc(
    DocTemplateId,
    Mode,
    Receiver,
    Subject,
    MessageBody,
    ItemOfServiceId,
    StartDate,
    EndDate,
    gender,
    min_age,
    max_age
  ) {
    const data = {
      DocTemplateId,
      Mode,
      Receiver,
      Subject,
      MessageBody,
      ItemOfServiceId,
      StartDate,
      EndDate,
      gender,
      min_age,
      max_age,
    };
    console.log(data);
    const url = `${this.url}/api/doctemplates/send`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  preview(
    gender: string,
    minAge: number,
    maxAge: number,
    startDate: string,
    endDate: string
  ) {
    const data = {
      gender,
      minAge,
      maxAge,
      startDate,
      endDate,
    };
    console.log(data);
    const url = `${this.url2}/api/Users/generateUsers?minAge=${minAge}&maxAge=${maxAge}&gender=${gender}&startDate=${startDate}&endDate=${endDate}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  sendDoc1(
    DocTemplateId,
    Mode,
    Receiver,
    Subject,
    MessageBody,
    ItemOfServiceId,
    StartDate,
    EndDate,
    gender,
    min_age,
    max_age
  ) {
    const data = {
      DocTemplateId,
      Mode,
      Receiver,
      Subject,
      MessageBody,
      ItemOfServiceId,
      StartDate,
      EndDate,
      gender,
      min_age,
      max_age,
    };
    console.log(data);
    const url = `${this.url}/api/doctemplates/send`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  getPatientsBySearch(serchText) {
    const url = `${this.url}/api/patient/getall?search=${serchText}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getPatientsBySearch1(serchText, st, ed, reg_no) {
    let url;
    if (serchText == null || serchText == undefined || serchText == '') {
      url = `${this.url}/api/patient/getall?startdate=${st}&enddate=${ed}&registration_no=${reg_no}`;
    } else {
      url = `${this.url}/api/patient/getall?search=${serchText}&startdate=${st}&enddate=${ed}`;
    }

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  gettemplates() {
    const url = `${this.url}/api/doctemplates/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  gettemplates1() {
    const url = `${this.url2}/api/Notifications/fetchAllTemplates`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getDocByServiceId(id) {
    const url = `${this.url}/api/doctemplates/getdetails?item_of_service_id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  gettemplatesMode(mode) {
    const url = `${this.url}/api/doctemplates/getall?mode=${mode}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  gettemplatesDetail(id) {
    const url = `${this.url}/api/doctemplates/getdetails?id=${id}`;

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getReceipt() {
    const url = `${this.url}/api/doctemplates/getdetails?id=184`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getLog() {
    const url = `${this.url}/api/doctemplates/log/getall`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getLogDetail(id) {
    const url = `${this.url}/api/doctemplates/log/getdetails?id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getItemOPD(id) {
    const url = `${this.url}/api/items/getall?opd_id=${id}`;

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getProfile() {
    const url = `${this.url}/api/accounts/user/getMyProfile`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getProfileonline() {
    const url = `${this.urlonline}/api/accounts/user/getMyProfile`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getUser() {
    const url = `${this.url}/api/accounts/user/getall`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getPatientType() {
    const url = `${this.url}/api/dropdown/patienttypes`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getRefHospCode() {
    const url = `${this.url}/api/dropdown/partners/patientorganization`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getConcessionCode() {
    const url = `${this.url}/api/dropdown/partners/financeconcession`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getSingleUser(id) {
    const url = `${this.url}/api/accounts/user/getall?id=${id}`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  getDesignation() {
    const url = `${this.url}/api/accounts/getPositions`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getUserById(id) {
    const url = `${this.url}/api/accounts/user/getall?id=${id}`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  deactivate(id) {
    const url = `${this.url}/api/accounts/disable?id=${id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  disableUser(id) {
    const url = `${this.url}/api/accounts/disable?id=${id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  enableUser(id) {
    const url = `${this.url}/api/accounts/enable?id=${id}`;
    console.log(url);

    return this.client.get(url, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }
  getPositionById(id) {
    const url = `${this.url}/api/accounts/enable?id=${id}`;
    console.log(url);

    const cacheData = localStorage.getItem(url);
    if (cacheData) return of(JSON.parse(cacheData));

    return this.client.get(url, options).pipe(
      map((data) => {
        localStorage.setItem(url, JSON.stringify(data));
        return data;
      }),
      catchError((error) => {
        return throwError(
          'Something went wrong please check your internet and try again'
        );
      })
    );
  }

  postUser(
    Employee_id: number,
    First_Name: string,
    Middle_Name: string,
    Last_Name: string,
    U_Name: string,
    Position_Id: number,
    Address: string,
    Phone_No: string,
    Email_id: string,
    Flag: string,
    designation: string,
    signature: string,
    password: string,
    IsDeleted: boolean,
    qualification: string,
    CanAuthDiscount: boolean
  ) {
    const data = {
      Employee_id,
      First_Name,
      Middle_Name,
      Last_Name,
      U_Name,
      Position_Id,
      Address,
      Phone_No,
      Email_id,
      Flag,
      designation,
      signature,
      password,
      IsDeleted,
      qualification,
      CanAuthDiscount,
    };
    console.log(data);
    const url = `${this.url}/api/accounts/user/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  postUseronline(
    Employee_id: number,
    First_Name: string,
    Middle_Name: string,
    Last_Name: string,
    U_Name: string,
    Position_Id: number,
    Address: string,
    Phone_No: string,
    Email_id: string,
    Flag: string,
    designation: string,
    signature: string,
    password: string,
    IsDeleted: boolean,
    qualification: string,
    CanAuthDiscount: boolean
  ) {
    const data = {
      Employee_id,
      First_Name,
      Middle_Name,
      Last_Name,
      U_Name,
      Position_Id,
      Address,
      Phone_No,
      Email_id,
      Flag,
      designation,
      signature,
      password,
      IsDeleted,
      qualification,
      CanAuthDiscount,
    };
    console.log(data);
    const url = `${this.urlonline}/api/accounts/user/save`;

    return this.client.post(url, data, options).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError('Something went wrong please try again');
      })
    );
  }

  constructor(private client: HttpClient, private conf: AppConfigService) {}
}
